export default __webpack_public_path__ + "20e19bc0d204bdb5a246ae849757d72f.png";